import { render, staticRenderFns } from "./rolesAuthorize.vue?vue&type=template&id=47eeae77&scoped=true"
import script from "./rolesAuthorize.vue?vue&type=script&lang=js"
export * from "./rolesAuthorize.vue?vue&type=script&lang=js"
import style0 from "./rolesAuthorize.vue?vue&type=style&index=0&id=47eeae77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eeae77",
  null
  
)

export default component.exports